import { render, staticRenderFns } from "./ExtendInfo.vue?vue&type=template&id=f410f862&"
import script from "./ExtendInfo.vue?vue&type=script&lang=js&"
export * from "./ExtendInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports